import * as angular from "angular";

export class SubTasksRequestsService {

  /* @ngInject */
  constructor(private SubTasksTemplatesAPI, private $subTasksTemplates) {
  }

  getTemplates(types) {
    const api = this.SubTasksTemplatesAPI.actions.getTemplates;
    return this.$$call(api, {type: types}, {}, {});
  }

  getTemplatesByIds(ids) {
    const api = this.SubTasksTemplatesAPI.actions.getTemplates;
    return this.$$call(api, {templateId: ids}, {}, {});
  }

  getTemplateActions() {
    const api = this.SubTasksTemplatesAPI.actions.getTemplateActions;
    return this.$$call(api, {}, {}, {});
  }

  createTemplate(template) {
    const api = this.SubTasksTemplatesAPI.actions.createTemplate;
    return this.$$call(api, {}, template, {});
  }

  updateTemplate(templateId, template) {
    const api = this.SubTasksTemplatesAPI.actions.updateTemplate;
    return this.$$call(api, {}, template, {templateId: templateId});
  }

  deleteTemplate(templateId) {
    const api = this.SubTasksTemplatesAPI.actions.deleteTemplate;
    return this.$$call(api, {}, {}, {templateId: templateId});
  }

  // ******************************
  // Internal methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    const $subTasksTemplatesRef = this.$subTasksTemplates();
    return $subTasksTemplatesRef.$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .service('subTasksRequestsService', SubTasksRequestsService);
